module.exports = __webpack_public_path__ + "img/edge_activites_montgolfiere.f4536cd8.svg";